import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, persistor, RootState, store } from "../store/store";
import { InteractionStatus } from "@azure/msal-browser";
import { useEffect, useState } from "react";
import { clearAccessToken } from "../store/modules/auth/authSlice";
import useInactivityTracker from "../hooks/useInactivityTracker";
import { logOut } from "./auth";

export default function AuthenticationHandler() {
  const { instance, inProgress } = useMsal();
  const [authChecked, setAuthChecked] = useState(false);

  const handleLogout = async () => {
    try {
      // Clear MSAL cache first
      await instance.clearCache();

      // Dispatch action to clear auth state
      store.dispatch(clearAccessToken());

      // Purge the persisted state and wait for it to complete
      await persistor.purge();

      // Wait a bit to ensure purge completes
      await persistor.flush();

      // Clear all storage
      localStorage.clear();
      sessionStorage.clear();

      // Finally, redirect to logout
      if (inProgress === InteractionStatus.None) {
        logOut(instance);
      }
    } catch (error) {
      console.error("Error during logout:", error);
      // Force clear even on error
      localStorage.clear();
      sessionStorage.clear();
      logOut(instance);
    }
  };

  useInactivityTracker(handleLogout, 600000); // 10 minutes

  const { tokenExpiration, isAuthenticated } = useSelector(
    (state: RootState) => state.auth
  );

  const { currentUser: user, loading: userLoading } = useSelector(
    (state: RootState) => state?.user
  );

  // Handle token expiration
  useEffect(() => {
    if (!authChecked && inProgress === InteractionStatus.None) {
      if (tokenExpiration && tokenExpiration < Date.now()) {
        // persistor.purge();
        // store.dispatch(clearAccessToken());
        // dispatch({ type: "LOGOUT" });

        console.log("Token expired, redirecting to login");
        // Delay the redirect slightly to ensure context is ready
        // setTimeout(() => {
        //   if (
        //     instance &&
        //     typeof instance.loginRedirect === "function" &&
        //     !userLoading &&
        //     inProgress === InteractionStatus.None
        //   ) {
        //     instance.loginRedirect(loginRequest).catch((e) => {
        //       console.error("Login redirect failed", e);
        //     });
        //   }
        // }, 200);
      }
      setAuthChecked(true);
    }
  }, [tokenExpiration]);

  return null;
}
